import { HttpParams } from "@angular/common/http";

interface BuilderParams {}

export class ObjectEmptyValuesRemover {
  object: BuilderParams;

  constructor(obj: BuilderParams) {
    this.object = { ...obj };
  }

  removeNullValues(): this {
    for (const key in this.object) {
      this.object[key] === null && delete this.object[key];
    }

    return this;
  }

  removeUndefinedValues(): this {
    for (const key in this.object) {
      this.object[key] === undefined && delete this.object[key];
    }

    return this;
  }

  removeEmptyStringValues(): this {
    for (const key in this.object) {
      this.object[key] === "" && delete this.object[key];
    }
    return this;
  }

  removeFalseValues(): this {
    for (const key in this.object) {
      this.object[key] === false && delete this.object[key];
    }
    return this;
  }

  build(): BuilderParams {
    return this.object;
  }
}

export function removeAllEmptyValues(obj: BuilderParams): BuilderParams {
  return new ObjectEmptyValuesRemover(obj)
    .removeEmptyStringValues()
    .removeUndefinedValues()
    .removeNullValues()
    .build();
}

export function populateParamsWithNotEmptyValues(
  builderParams: BuilderParams,
  params: HttpParams
): HttpParams {
  Object.entries(builderParams).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      params = params.append(key, value.toString());
    }
  });

  return params;
}
